import React from 'react';
import PropTypes from 'prop-types';

import Text from '@redbubble/design-system/react/Text';
import Box from '@redbubble/design-system/react/Box';
import * as constants from '@redbubble/design-system/react/constants';

const CarouselHeading = ({ profile, children, actionSlot }) => {
  return (
    <Box
      marginBottom={profile === constants.MOBILE ? 1 : 1.5}
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Box>
        <Text type="display2" element="h2">
          {children}
        </Text>
      </Box>

      {actionSlot && <Box>{actionSlot}</Box>}
    </Box>
  );
};

CarouselHeading.propTypes = {
  profile: PropTypes.oneOf([constants.MOBILE, constants.DESKTOP]),
  children: PropTypes.node.isRequired,
  actionSlot: PropTypes.node
};

CarouselHeading.defaultProps = {
  profile: constants.MOBILE,
  actionSlot: null
};

export default CarouselHeading;
